const theme = {
  color: {
    black: "#000",
    silver: "#ccc",
    alto: "#ddd",
    gallery: "#eee",
    white: "#fff",
    teal: "#007380",
    crimson: "#db143c",
    forestGreen: "#228c22",
    red: "#ff0000",
  },
  breakpoint: {
    mobileMax: "767px",
    mobileMin: "321px",
  },
};

export default theme;